import type { AggregateResponse, SessionResult } from '../types';

export async function fetchAggregate(): Promise<AggregateResponse | null> {
  const response = await fetch('/api/aggregate', { headers: { accept: 'application/json' } });
  if (!response.ok) return null;
  return (await response.json()) as AggregateResponse;
}

export async function submitResult(result: SessionResult, turnstileToken: string): Promise<{ ok: true; id: string } | { ok: false; error: string }> {
  const response = await fetch('/api/submit', {
    method: 'POST',
    headers: { 'content-type': 'application/json', accept: 'application/json' },
    body: JSON.stringify({
      turnstileToken,
      result: {
        ...result,
        trials: result.trials.map((trial) => ({
          index: trial.index,
          delta: trial.delta,
          correct: trial.correct,
          rtMs: trial.rtMs,
          target: trial.target,
          answer: trial.answer
        }))
      }
    })
  });
  const body = (await response.json()) as { ok: boolean; id?: string; error?: string };
  if (!response.ok || !body.ok) return { ok: false, error: body.error ?? `HTTP ${response.status}` };
  return { ok: true, id: body.id ?? result.id };
}
